import ChatContext from "./ChatContext";
import { useState } from "react";
import ACTIONS from "../Components/Actions";

export default function ChatContextProvider({ children }){
    const [message, setMessage] = useState("");

    const [messageList, setMessageList] = useState([]);
    async function sendMessage(socketRef,username,roomId,message) {
      const messageData = {
        roomId: roomId,
        username: username,
        message: message,
        time: (new Date()).getHours() + ":" + (new Date()).getMinutes()
      }
      setMessageList(prev => [...prev, {
        roomId: messageData.roomId,
        username: messageData.username,
        message: messageData.message,
        time:messageData.time,
        type:"send"}]);
      await socketRef.emit(ACTIONS.SENDMESSAGE, messageData);
    }
  
    async function receiveMessage(socketRef) {
        if(socketRef!==null){
          socketRef.on(ACTIONS.RECEIVEMESSAGE, (data) => {
            // eslint-disable-next-line
            console.log(data)
            const receiveMessage = {
              roomId: data.roomId,
              username: data.username,
              message: data.message,
              time: data.time
            }
            setMessageList(prev=>[...prev,{
              roomId: receiveMessage.roomId,
              username: receiveMessage.username,
              message: receiveMessage.message,
              time:receiveMessage.time,
              type:"receive"}])
            }
            );
        }
      }

  return <ChatContext.Provider value={{message,setMessage,messageList,setMessageList,sendMessage,receiveMessage}}>
    {children}
  </ChatContext.Provider>;
};
